<template>
  <Page>
    <div :class="$style['page']">
      <div v-if="results" class="container container--small">
        <div :class="$style['breadcrumbs']">
          <NuxtLink :to="{ name: $lang + '-vacancies' }">
            {{ $t('static/our-vacancies') }}
          </NuxtLink>
          <template v-if="route.params.city">
            &nbsp;/
            <NuxtLink
              :to="{
                name: $lang + '-vacancies-city',
                params: { city: results.locationSlug }
              }">
              {{ results.location }}
            </NuxtLink>
          </template>
        </div>
        <h1>{{ results.title }}</h1>
        <h4 class="base-font h5">
          {{ results.employment }} - {{ results.location }}
        </h4>
        <div
          class="h-margin-top"
          v-html="results.body" />
        <Btn
          v-if="results.applyNow"
          color="cta">
          {{ $t('vacancies/apply-now') }}
        </Btn>
        <ServiceBanner class="h-margin-top-xl" />
      </div>
    </div>
  </Page>
</template>
<script setup>
import {
  formatCanonical,
  formatOpenGraph,
  formatMetaDescription
} from '~/helpers/metadata'
const route = useRoute()
const { $lang, $api } = useNuxtApp()
await useI18n(['static', 'vacancies'])

const { data, error } = await useAsyncData(`vacancies-city-${route.params.vacancy}`, async () => {
  const [results, navigation] = await Promise.all([
    $api(`/jobs/${route.params.vacancy}`),
    $api(`navigation/8?encoded_url=${encodeURIComponent(route.path)}`)
  ])

  return { results, navigation }
})

const results = computed(() => data.value.results)
const navigation = computed(() => data.value.navigation)

const metaData = navigation.value.metaData

if (error.value) {
  throw showError({ statusCode: 404, statusMessage: 'vacancy_not_found' })
}

if (results.value) {
  useHead({
    title: results.value.title,
    link: [...formatCanonical(metaData)],
    meta: [
      ...formatOpenGraph(metaData.openGraph),
      formatMetaDescription(metaData)
    ],
    script: [{ type: 'application/ld+json', innerHTML: metaData.schemaOrg }] // Structured data
  })
}

</script>
<style lang="scss" module>
.page {
  p {
    margin-bottom: $spacing * 2;
  }

  ul {
    margin-bottom: $spacing * 3;
    list-style-position: outside;
    padding-left: $spacing * 2;
  }

  p:first-child {
    margin-bottom: $spacing * 3;
  }

  .breadcrumbs {
    margin-bottom: $spacing * 2;
  }
}
</style>
